module.exports = __webpack_public_path__ + "media/images/emblems/Hochfelden-blazon-c80e2c18aaa170ac61997ee35c192058.svg";